export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_04.73576cb2.mp4";